<template>
  <!-- 底部 -->
  <!-- 底部 -->
  <div class="fotter">
      <div class="pageW">
        <p class="my">
          <span  @click="goRouter('/my?type=0')">网站简介</span>-
          <span  @click="goRouter('/my?type=4')">联系我们</span>-
          <span  @click="goRouter('/my?type=1')">营销服务</span>-
          <span  @click="goRouter('/my?type=2')">本站历程</span>-
          <span  @click="goRouter('/my?type=3')">版权声明</span>
        </p>
        <div>
          <p>徐州报业传媒集团主办  徐州报业网络传播有限公司承办</p>
          <p>中国徐州网 版权所有 Copyright 1999-2022 徐州报业网络传播有限公司</p>
          <p>
            <span>苏ICP备05003658号-1</span>
            <img src="https://hfy-img.xzyunchuang.com/1537a0d8993643de5252cf7bcd6e0dbe"/>
            苏公网安备 32039302000101号
          </p>
          <p>
            <span>中国徐州网 - 新兴主流媒体 徐州城市门户</span>
            | 广播电视节目制作经营许可证00219号 | 网络视听许可证1009344号 | 互联网出版许可证0014号 | 互联网新闻信息服务许可证32120170012
          </p>
<!--          <p>晨报热线：0516-85800100   晚报热线：0516-85608110   日报热线：0516-85600213</p>-->
          <p>徐州报业传媒集团常年法律顾问单位：江苏典锐律师事务所</p>
          <p>联系电话：0516－85600213</p>
          <p>技术支持：徐州云创数字科技有限公司</p>
          <div class="img1">
<!--            <img  src="http://hfy-img.xzyunchuang.com/5d38b8a88f4a40a790f99d738ecd8dbc"/>-->
            <img  src="https://hfy-img.xzyunchuang.com/2014606021159133184.png"/>
          </div>
          <a href="https://bszs.conac.cn/sitename?method=show&amp;id=1FFBA56A2AD9252DE053012819ACA3AC" target="_blank">
            <img class="img2" src="https://hfy-img.xzyunchuang.com/36ce5328b8cb60f48b5dbfbe02c17f46"/>
          </a>
        </div>
      </div>
    </div>
</template>
<script>

export default {
name: 'contactUs',
data() {
return {
   botInfo:{}
}
},
mounted(){

},
methods: {
  goRouter(d){
    window.open(d, "_blank");
    // window.location.href=d;
  }

}
}
</script>
<style scoped lang="scss">
.fotter{
    background: #F9F9F9;
    border-top: 1px solid #e1e1e1;
    padding: 50px 0;
    text-align: center;
    font-size: 14px;

    .my{
      margin-bottom: 20px;

      span {
        font-size: 14px;
        margin: 0 10px;
        cursor: pointer;
        &:hover{
        border-bottom: 1px solid #333;
      }
    }
    }
    .pageW{
      p{
        font-size: 12px;
        color: #666;
        height: 24px;
        line-height: 24px;
        img{
           height: 20px;
           margin-bottom: -4px;
        }
      }
      div{
        .img1{
          margin: 20px 0 10px 0;
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/bot.vue